import { createSelector } from 'reselect'
import { getUserAddressSelector } from 'modules/address/selectors'
import { isUnrecognizedAddressShippingUtil } from 'modules/shipping/utils/is-unrecognized-address'

function isUnrecognizedAddressShippingSelector () {
  return createSelector(
    getUserAddressSelector(),
    state => state && state.shipping,
    (address, shipping) => isUnrecognizedAddressShippingUtil(
      address, shipping
    )
  )
}

export {
  isUnrecognizedAddressShippingSelector
}
